import LandscapeNotifier from './LandscapeNotifier';

export default LandscapeNotifier;
